import { Injectable, EventEmitter, Output, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StorageAplicationService } from './storage-aplication.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from 'src/app/models/shared/user';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { EnumRoutesDefault } from '../models/shared/app-enums';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  private cookieService = inject(CookieService);
  @Output() change: EventEmitter<boolean> = new EventEmitter();
  sesionActive$ = new EventEmitter<boolean>();
  currentUserSubject: BehaviorSubject<User>;
  currentUser: Observable<User>;

  constructor(private readonly storage: StorageAplicationService,
    private readonly http: HttpClient, private readonly router: Router,
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser') || '{}'));
    this.currentUser = this.currentUserSubject.asObservable();
  }


  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(username: string, password: string): any {
    return this.http.post<any>('/auth/', { username, password }, { observe: 'response' })
      .pipe(map(resp => {
        console.log(resp);
        let _exist = this.onCheckUserInStorage(resp.body.id);
        const token = resp.headers.get('X-AUTH-TOKEN');

        if (resp && token && !_exist) {
          resp.body.token = token;
          localStorage.setItem('token', token);
          localStorage.setItem('TokenEmi', token);
          localStorage.setItem('currentUser', JSON.stringify(resp.body));
          localStorage.setItem('photoUser', resp.body.photo);
          localStorage.setItem('userName', resp.body.nombre);
          localStorage.setItem('userId', resp.body.id);
          localStorage.setItem('companyName', resp.body.nameCompany);


          this.onCreateUpdateCookieUser(resp.body);

          if (resp.body.branches != null) {
            if (resp.body.branches[0] != undefined)
              localStorage.setItem('branchId', resp.body.branches[0].id);
          }
          this.currentUserSubject.next(resp.body);

          this.router.navigate([EnumRoutesDefault.UserCae]);
          return resp.body;
        }
        else if (_exist) {
          console.log("Sesión con otro usuario");
          resp.body.info = "UserInSession";
          return resp.body;
        }
        else {
          return resp;
        }
      }));
  }

  recoveryPassword(email: string): any {
    this.http.post<any>('/auth/recoveryPassword', { email }).subscribe(
      (response: any) => {
        console.log('RESPUESTA DE recoveryPassword: ', response);
      }, (error: Response) => {
        console.log('ERROR recoveryPassword: ', error);
      });
  }

  updateUser(model: User): Observable<any> {
    let currentUser = this.currentUserValue;
    const headers = new HttpHeaders({
      'content-type': 'application/json',
      // 'Access-Control-Allow-Origin': '*',
      // 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers,X-Access-Token,XKey,Authorization',
      'Authorization': `Bearer ${currentUser.token}`
    });
    let user = JSON.stringify(model);
    return null;
  }

  loggedIn(): boolean {
    if (this.storage.getDataSesionStorage('isLoggin')) {
      return true;
    } else {
      return false;
    }
  }

  logout() {
    this.currentUserSubject.next(null);
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentPage');
  }

  onCheckUserInStorage(idCurrent: string): boolean {
    let _result = true;
    let _userId = localStorage.getItem("s_olduser");
    if (_userId != null) {
      let id = _userId.toString();
      if (id == idCurrent) {
        _result = false;
      }
    }
    else {
      //Si no existe registro en sesión entonces se crea uno
      localStorage.setItem('s_olduser', idCurrent);
      _result = false;
    }
    return _result;
  }

  onValidateCookieUserUI() {
    let _old = this.cookieService.get('userId');

    //Obtener valor de usuario desde localStorage
    let userData = JSON.parse(localStorage.getItem('currentUser'));

    if (userData?.id) {
      const newTabCount = localStorage.getItem('s_tabsOpen');
      if (newTabCount == null) {
        this.logout();
      }
      else if (_old == userData.id.toString()) {
        this.cookieService.set('userId', userData.id.toString());
        window.location.reload();
      }
    }
  }

  onUpdateTabsCount() {
    //Incrementa
    const tabsOpen = localStorage.getItem('s_tabsOpen');
    if (tabsOpen == null) {
      localStorage.setItem('s_tabsOpen', '1');
    } else {
      let _value = (parseInt(tabsOpen) + 1).toString();
      localStorage.setItem('s_tabsOpen', _value);
    }

    //Decrementa
    window.onunload = function (e) {
      const newTabCount = localStorage.getItem('s_tabsOpen');
      let _value = (parseInt(newTabCount) - 1).toString();
      if (newTabCount !== null) {
        localStorage.setItem('s_tabsOpen', _value);
      }
    }
  }

  onClearDataUser() {
    this.logout();
    localStorage.setItem('logueado', "0");
    localStorage.removeItem('currentUser');
    localStorage.clear();
    sessionStorage.clear();
    this.cookieService.deleteAll();
  }

  //Método que crea o actualiza la cookie del usuario en sesión
  onCreateUpdateCookieUser(res: any) {
    let _old = this.cookieService.get('userId');
    if (_old != undefined && _old != '' && _old != null) {
      if (_old == "null") {
        this.cookieService.set('userId', res.id);
      }
      else if (_old != res.id.toString()) {
        console.info("Inicio de sesión con otro usuario");
      }
    }
    else {
      this.cookieService.set('userId', res.id);
    }
  }

  getPosition(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resp => {
        resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
      },
        err => {
          reject(err);
        });
    });
  }
}
